$(document).ready(function(){

	$("#send-and-subcribe-to-mailchimp").bind("click", function(){

		var email = $("#ContactEmail").val();
		var name = $("#ContactName").val();
		var isFullname = false;

		if (name.indexOf(' ') >= 0) {
			var parts = name.split(" ");
			var firstname = parts[0];
			var lastname = parts[1];
			isFullname = true;
		}

		var data = {"EMAIL": email};

		if (isFullname) {
			data['FNAME'] = firstname;
			data['LNAME'] = lastname;
		}
		else {
			data['FNAME'] = name;
		}

		$.post("http://thewatersedge.us2.list-manage.com/subscribe/post?u=5ea5339de43f70d3726e25e68&amp;id=24c1d0cc01", data)
			.done(function(res) {
				console.log('Subscribed!');
			});

	});

});